import constants from 'constants';

const {
  MODAL_TYPE_DELETE_CONFIRMATION,
  MODAL_DELETE_CONFIRMATION_TYPE,
  SHOW_MODAL
} = constants;

const showModal = (modalType, modalContentProps = {}) => ({
  type: SHOW_MODAL,
  modalType,
  modalContentProps
});

export const showDeleteWebinarsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.webinar
  })
};

export const showDeleteSponsorsConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.sponsor
  })
};

export const showDeleteUsersConfirmationModal = (ids) => {
  return showModal(MODAL_TYPE_DELETE_CONFIRMATION, {
    ids,
    type: MODAL_DELETE_CONFIRMATION_TYPE.user
  })
};



/** WEBPACK FOOTER **
 ** ./src/actions/mixed.js
 **/